import { Component, Input } from '@angular/core';
import { DataCard } from "../../models/information-dashboard.model";


@Component({
  selector: 'app-info-dashboard-card',
  templateUrl: './info-dashboard-card.component.html',
  styleUrl: './info-dashboard-card.component.scss'
})
export class InfoDashboardCardComponent {

  private _data: DataCard[] = [] as DataCard[];
  @Input()
    set data(value: DataCard[]) {
      this._data = value;
    }
    get data(): DataCard[]{
      return this._data;
    };

  formatNumber(number: number): string {
    const formateador = new Intl.NumberFormat('es-MX', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return `$${formateador.format(number)}`;
  }

}
